// Globals
import { FC, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Models
import { IPromotion } from '@/models/promotion.model';

// Components
import { Table } from '@/ui';
import EditCouponModal from '../EditCouponModal/EditCouponModal';

// Helpers
import { getCouponsColumns } from '../../helpers';

type TCouponsTableProps = {
  coupons: IPromotion[] | null;
  isLoading: boolean;
};

const CouponsTable: FC<TCouponsTableProps> = ({ coupons, isLoading }) => {
  const { t } = useTranslation(['common']);
  const [selectedCoupon, setSelectedCoupon] = useState<IPromotion | null>(null);

  const columns = useMemo(() => getCouponsColumns(t), [t]);

  const handleDeselectCoupon = () => {
    setSelectedCoupon(null);
  };

  return (
    <>
      <Table
        columns={columns}
        rowKey="id"
        onRow={(record) => ({
          onClick: () => setSelectedCoupon(record),
        })}
        dataSource={coupons ?? []}
        loading={isLoading}
        pagination={false}
        virtual
        rowHoverable
      />
      <EditCouponModal coupon={selectedCoupon} isOpen={!!selectedCoupon} onClose={handleDeselectCoupon} />
    </>
  );
};

export default CouponsTable;
